export default "__VITE_ASSET__kug4UN8L__"